module.exports = __webpack_public_path__ + "static/img/steps_3.f702023.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/official/steps_3.png
// module id = 0cyP
// module chunks = 0